import state from './store/state'
import mutations from './store/mutations'
import actions from './store/actions'
import getters from './store/getters'
import configStore from './config/config.store'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    configs: configStore
  }
}
